import axios from "axios"
import Swal from "sweetalert2"
import { itemsPerPage } from "./global-actions-data"
import { getFormattedHeaders } from "./global-actions"

const apiUrl = process.env.REACT_APP_API_URL

// Error handler utility
const handleApiError = (
  error,
  defaultMessage = "Hubo un error, vuelve a intentarlo, Si el error persiste contacte al administrador.",
) => {
  if (error.response) {
    if (error.response.status === 400) {
      Swal.fire({
        title: "¡Error!",
        confirmButtonColor: "#76b4ff",
        text: error.response.data.message || defaultMessage,
      })
    } else {
      Swal.fire({
        title: "¡Error!",
        confirmButtonColor: "#76b4ff",
        text: defaultMessage,
      })
    }
  } else if (error.request) {
    console.log(error.request)
    Swal.fire({
      title: "¡Error!",
      confirmButtonColor: "#76b4ff",
      text: defaultMessage,
    })
  } else {
    console.log("Error", error.message)
    Swal.fire({
      title: "¡Error!",
      confirmButtonColor: "#76b4ff",
      text: defaultMessage,
    })
  }
}

export const createProperty = async (data, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.post(`${apiUrl}/property`, data, {
      headers: {
        token,
      },
    })

    return result.data
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getProperties = async (skip, setLoading, token, filters = {}) => {
  try {
    setLoading?.(true)
    const params = {
      skip,
      limit: itemsPerPage,
      ...filters,
    }

    const result = await axios.get(`${apiUrl}/property`, {
      headers: {
        token,
      },
      params,
    })

    const headersNeeded = ["totalitems", "totalpages", "currentpage"]
    const headers = getFormattedHeaders(result.headers, headersNeeded)
    const response = { data: result.data, headers }

    return response
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getProperty = async (id, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/property`, {
      headers: {
        token,
      },
      params: {
        skip: 0,
        limit: 0,
        query: JSON.stringify({
          _id: id,
        }),
      },
    })

    return result.data
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const updateProperty = async (data, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.put(`${apiUrl}/property/${data._id}`, data, {
      headers: {
        token,
      },
    })

    return result
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const createRequest = async (data, setLoading) => {
  try {
    setLoading?.(true)
    const result = await axios.put(
      `${apiUrl}/property/create-request/${data._id}`,
      data,
      {
        headers: {},
      },
    )

    return result
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getPropertyByCode = async (code, setLoading) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/property`, {
      params: {
        skip: 0,
        limit: 0,
        query: JSON.stringify({
          code,
        }),
      },
    })

    return result.data
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getRequests = async (id, skip, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/request`, {
      headers: {
        token,
      },
      params: {
        skip,
        limit: itemsPerPage,
        query: JSON.stringify({
          propertyID: id,
        }),
      },
    })

    const headersNeeded = ["totalitems", "totalpages", "currentpage"]
    const headers = getFormattedHeaders(result.headers, headersNeeded)
    const response = { data: result.data, headers }

    return response
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getRequest = async (id, setLoading, token) => {
  try {
    setLoading?.(true)
    const result = await axios.get(`${apiUrl}/request`, {
      headers: {
        token,
      },
      params: {
        skip: 0,
        limit: 0,
        query: JSON.stringify({
          _id: id,
        }),
      },
    })

    return result.data
  } catch (error) {
    handleApiError(error)
    throw error
  } finally {
    setLoading?.(false)
  }
}

export const getAllOwnersWithProperties = async (token) => {
  try {
    const result = await axios.get(
      `${apiUrl}/property/users-with-properties/all`,
      {
        headers: {
          token,
        },
      },
    )

    if (result.data.code === "01") {
      throw new Error(result.data.message)
    }

    return result.data.data
  } catch (error) {
    console.error("Error fetching owners with properties:", error)
    return []
  }
}

export const deactivateProperty = async (propertyId, token) => {
  try {
    const result = await axios.put(
      `${apiUrl}/property/deactivate/${propertyId}`,
      {},
      {
        headers: {
          token,
        },
      },
    )

    if (result.data.code === "01") {
      Swal.fire({
        title: "¡Error!",
        confirmButtonColor: "#76b4ff",
        text: result.data.message,
      })
      return false
    }

    Swal.fire({
      title: "¡Éxito!",
      confirmButtonColor: "#76b4ff",
      text: "Propiedad desactivada correctamente",
      icon: "success",
    })
    return true
  } catch (error) {
    handleApiError(error, "Error al desactivar la propiedad")
    return false
  }
}
